import { render, staticRenderFns } from "./ChallengeDescription.vue?vue&type=template&id=51ef6926&"
import script from "./ChallengeDescription.vue?vue&type=script&lang=js&"
export * from "./ChallengeDescription.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports